module.exports = __webpack_public_path__ + "static/img/application5-2.fa5546e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application5/application5-2.jpg
// module id = gTs4
// module chunks = 0